(() => {
  if (customElements.get('mdf-complete-gift')) return;
  customElements.define('mdf-complete-gift', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.messages = Object.fromEntries(Array.from(this.querySelectorAll('[data-gift-message]'), node => [node.dataset.giftMessage,node.textContent]));
      this.money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en',{style:'currency',currency:this.dataset.currency || 'USD'}).format(amount / 100);
      this.addEventListener('change', event => {
        if (!event.target.matches('.mdf-gift-card select')) return;
        event.stopPropagation();
        this.showSelection(event.target.closest('.mdf-gift-card'),event.target.selectedOptions[0]);
      });
      this.addEventListener('submit', event => this.addGift(event));
    }
    t(key) { return this.messages[key] || key; }
    showSelection(card, option) {
      if (!option || !option.value || option.disabled) return;
      card.querySelector('[data-gift-price]').textContent = '+' + option.dataset.price;
      const image = card.querySelector('img');
      if (image && option.dataset.image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
      if (image) image.alt = option.textContent.trim();
      card.querySelector('[data-gift-link]').href = option.dataset.url;
      card.querySelector('[data-gift-link]').setAttribute('aria-label',option.textContent.trim());
      card.querySelector('[role="status"]').textContent = '';
      card.querySelector('.mdf-gift-cart').hidden = true;
      card.querySelector('button').disabled = !!this.busy;
    }
    async json(url, options = {}) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(),15000);
      try {
        const response = await fetch(url,{...options,cache:'no-store',signal:controller.signal,headers:{Accept:'application/json',...options.headers}});
        const data = await response.json();
        if (!response.ok || data.status) throw new Error('Request not confirmed');
        return data;
      } finally { clearTimeout(timeout); }
    }
    present(cart, productId) { return cart.items.some(item => String(item.product_id) === String(productId)); }
    confirmed(cart, choices) {
      return Array.isArray(choices) && choices.length > 0 && choices.every(choice => cart.items.some(item => String(item.product_id) === String(choice.productId) && String(item.variant_id) === String(choice.id) && item.quantity >= 1 && Object.entries(choice.properties || {}).every(([key,value]) => item.properties?.[key] === value)));
    }
    cartBlocked(form, ownedMain = null) {
      const main = this.closest('main-cart');
      const unconfirmed = main?.hasAttribute('data-mdf-cart-unconfirmed');
      if (!unconfirmed && (!main?.hasAttribute('aria-busy') || main === ownedMain)) return false;
      form.querySelector('[role="status"]').textContent = this.t(unconfirmed ? 'review' : 'busy');
      form.querySelector('.mdf-gift-cart').hidden = !unconfirmed;
      return true;
    }
    async addGift(event) {
      const form = event.target;
      if (!form.matches('.mdf-gift-card form')) return;
      event.preventDefault();
      event.stopPropagation();
      if (this.busy || form.dataset.busy) { form.querySelector('[role="status"]').textContent = this.t('busy'); return; }
      if (this.cartBlocked(form) || !form.reportValidity()) return;
      const select = form.querySelector('select');
      const option = select ? select.selectedOptions[0] : form.querySelector('input[name="id"]');
      if (!option || !/^\d+$/.test(option.value) || !/^\d+$/.test(option.dataset.product || '') || !option.dataset.productUrl || option.disabled || option.dataset.available === 'false') return;
      const main = this.closest('main-cart');
      const card = form.closest('.mdf-gift-card'), button = form.querySelector('button'), status = form.querySelector('[role="status"]');
      this.busy = true;
      main?.setAttribute('aria-busy','true');
      form.dataset.busy = 'true';
      form.setAttribute('aria-busy','true');
      form.querySelector('.mdf-gift-cart').hidden = true;
      button.disabled = true;
      if (select) select.disabled = true;
      status.textContent = this.t('adding');
      let posted = false, added = false, keepDisabled = false, needsReview = false;
      try {
        const cart = await this.json(this.dataset.cartUrl);
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart');
        const pendingText = sessionStorage.getItem('mdf-gesture-pending');
        if (pendingText) {
          needsReview = true;
          const pending = JSON.parse(pendingText);
          if (!this.confirmed(cart,pending)) { main?.setAttribute('data-mdf-cart-unconfirmed',''); status.textContent = this.t('review'); form.querySelector('.mdf-gift-cart').hidden = false; return; }
          sessionStorage.removeItem('mdf-gesture-pending');
          needsReview = false;
        }
        if (this.present(cart,option.dataset.product)) { status.textContent = this.t('already'); form.querySelector('.mdf-gift-cart').hidden = false; keepDisabled = true; return; }
        const product = await this.json(option.dataset.productUrl + '.js');
        const variant = product.variants?.find(item => String(item.id) === option.value);
        if (String(product.id) !== option.dataset.product || !variant?.available || !Number.isFinite(variant.price)) { option.disabled = true; keepDisabled = !select; status.textContent = this.t('unavailable'); return; }
        if (variant.price !== Number(option.dataset.priceCents)) {
          option.dataset.priceCents = String(variant.price);
          option.dataset.price = this.money(variant.price);
          const label = product.title + (variant.title === 'Default Title' ? '' : ' · ' + variant.title) + ' · ' + this.money(variant.price);
          if (select) { option.textContent = label; this.showSelection(card,option); } else { option.dataset.singleLabel = label; card.querySelector('[data-gift-price]').textContent = '+' + this.money(variant.price); }
          status.textContent = this.t('changed'); return;
        }
        if (this.cartBlocked(form,main)) return;
        const pending = [{id:variant.id,productId:product.id,properties:{}}], text = JSON.stringify(pending);
        if (sessionStorage.getItem('mdf-gesture-pending')) { main?.setAttribute('data-mdf-cart-unconfirmed',''); status.textContent = this.t('review'); form.querySelector('.mdf-gift-cart').hidden = false; return; }
        sessionStorage.setItem('mdf-gesture-pending',text);
        if (sessionStorage.getItem('mdf-gesture-pending') !== text) throw new Error('Pending record unavailable');
        posted = true;
        try { await this.json(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1}]})}); } catch {}
        const readback = await this.json(this.dataset.cartUrl);
        if (!Array.isArray(readback.items) || !this.confirmed(readback,pending)) throw new Error('Addition not confirmed');
        if (main) {
          if (typeof main.update !== 'function') throw new Error('Cart view not refreshed');
          let timeout;
          try {
            if (!await Promise.race([main.update(),new Promise((_,reject) => { timeout = setTimeout(() => reject(new Error('Cart refresh timed out')),this.refreshTimeout || 15000); })])) throw new Error('Cart view not refreshed');
          } finally { clearTimeout(timeout); }
        }
        sessionStorage.removeItem('mdf-gesture-pending');
        added = true; keepDisabled = true;
        status.textContent = this.t('added').replace('__PRODUCT__',product.title + (variant.title === 'Default Title' ? '' : ' · ' + variant.title));
        form.querySelector('.mdf-gift-cart').hidden = false;
      } catch {
        if (posted || needsReview) main?.setAttribute('data-mdf-cart-unconfirmed','');
        status.textContent = this.t(posted || needsReview ? 'review' : 'error');
        form.querySelector('.mdf-gift-cart').hidden = !(posted || needsReview);
      } finally {
        main?.removeAttribute('aria-busy');
        this.busy = false;
        delete form.dataset.busy;
        form.removeAttribute('aria-busy');
        button.disabled = keepDisabled;
        if (select) select.disabled = false;
      }
      if (added && !main) this.dispatchEvent(new CustomEvent('updateCart',{bubbles:true,composed:true,detail:{callback:()=>{}}}));
    }
  });
})();
